export const isLoading = (state) => state.isLoading;
export const isLoaded = (state) => state.success || state.error !== null;
export const isSuccess = (state) => state.success;
export const shouldLoad = (state) => !isLoading(state) && !isLoaded(state);
